// components/ui/StatsCard.jsx
import React from 'react';
import { Card, Typography, Box } from '@mui/material';

export const StatsCard = ({ number, label, suffix = '', animate = false }) => {
  return (
    <Card sx={{ p: 3, textAlign: 'center' }}>
      <Typography
        variant="h3"
        sx={{
          fontWeight: 'bold',
          background: 'linear-gradient(45deg, #ffffff, #ff4d4d)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          color: 'transparent',
          animation: animate ? 'float 2s ease-in-out infinite' : 'none',
        }}
      >
        {number}{suffix}
      </Typography>
      <Typography variant="h6" sx={{ color: 'rgba(255, 255, 255, 0.8)', mt: 1 }}>
        {label}
      </Typography>
    </Card>
  );
};